import { ApiWeeklySchedule } from 'apis/merchant-onboarding-service/types';

import { TimePairsByWeekday } from './WeeklyScheduleInput/types';

type VenueRequest = {
  name: string;
  address: string;
  postCode: string;
  city: string;
  isWoltCity: boolean;
  openingTimes: ApiWeeklySchedule;
};

export type VenueFormValues = Omit<VenueRequest, 'openingTimes'> & {
  otherCity: string;
  openingHours: TimePairsByWeekday;
};

export type PhoneNumber = {
  extension: string;
  number: string;
};

export type SelfServeSignupValues = {
  /** first name of contact person */
  firstName: string;
  /** last name of contact person */
  lastName: string;
  /** name of the merchant's business */
  name: string;
  phoneNumber: PhoneNumber;
  email: string;
  venues: VenueFormValues;
  // website: string | undefined; TODO: uncomment when website field is added back
  businessId: string;
  businessType: string;
  country: string;
  language: string;
};

export type SelfServeSignupRequest = {
  /** first name of contact person */
  firstName: string;
  /** last name of contact person */
  lastName: string;
  /** name of the merchant's business */
  name: string;
  phoneNumber: string;
  email: string;
  venues: VenueRequest[];
  // website: string | undefined; TODO: uncomment when website field is added back
  businessId: string;
  businessType: string;
  country: string;
  language: string;
  tags: SelfServeSignupTag[];
  woltUid: string | null;
};

export type SelfServeSignupTag = {
  name: string;
  value: string;
};

export enum SelfServeSignupTagName {
  UTM_SOURCE,
  UTM_MEDIUM,
  UTM_CAMPAIGN,
  UTM_CONTENT,
  UTM_TERM,
}

type LocalizedValue = {
  lang: string;
  value: string;
};

type CityConfig = {
  id: string;
  slug: string;
  name: LocalizedValue[];
};

export type CountryConfig = {
  code: string;
  name: string;
  cities: CityConfig[];
};

export type TrialCommission = {
  commissionValue: string;
  commissionDuration: number;
};

export type CommissionsConfig = {
  deliveryCommission?: string;
  takeawayCommission?: string;
  subscriptionCommission?: string;
  selfDeliveryCommission?: string;
  selfDeliverySubscriptionCommission?: string;
  trialCommission?: TrialCommission;
};

export type TabletType = 'IPAD' | 'ANDROID';

export type TabletConfiguration = {
  tabletType: TabletType;
  tabletCost: string;
};

export type DevicesConfig = {
  tabletConfiguration: TabletConfiguration;
  mobileDataOption?: {
    cost: string;
  };
  printerOptionConfiguration?: {
    cost: string;
  };
};

export type MenuPhotoShootOption = 'MERCHANT_OWN_PHOTO' | 'WOLT_PHOTOSHOOT' | 'WOLT_STOCK_PHOTOS';

export type SsmoCountryConfig = {
  commissionsConfig: CommissionsConfig;
  devicesConfig: DevicesConfig;
  menuPhotoShootPricingConfig: Map<MenuPhotoShootOption, string>;
};
